module.exports = __webpack_public_path__ + "static/media/logo_softseguros.b54455dc.png";